import { createContext, useContext } from 'react';

var MotionContext = createContext({});
function useVisualElementContext() {
    return useContext(MotionContext).visualElement;
}

export { MotionContext, useVisualElementContext };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/context/MotionContext/index.mjs
// module id = sHdw
// module chunks = 0